import { Helmet } from "react-helmet";
import "../../styles/TermsAndConditions.css";
import { siteUrl } from "../Blogs/data";
const TermsAndConditions = () => {
  return (
    <>
      <Helmet>
        <title>{"Orion Stars 777 Slots - Terms and Conditions"}</title>
        <meta
          name="description"
          content={
            "By accessing or using our platform, you agree to the terms outlined here, forming a legal agreement between you and Orion Stars."
          }
        />
        <link
          rel="canonical"
          href={`${siteUrl}/terms-and-conditions/orion-stars-777-slots-terms-and-conditions`}
        />
        {/* OG Tags */}
        <meta
          property="og:title"
          content={"Orion Stars 777 Slots - Terms and Conditions"}
        />
        <meta property="og:site_name" content="Orion star 777 Slots/" />
        <meta
          property="og:url"
          content={`${siteUrl}/terms-and-conditions/orion-stars-777-slots-terms-and-conditions`}
        />
        <meta
          property="og:description"
          content={
            "By accessing or using our platform, you agree to the terms outlined here, forming a legal agreement between you and Orion Stars."
          }
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={""} />
        <meta property="og:type" content="article" />
      </Helmet>
      <div className="termsAndConditions__container">
        <h1>Orion Star Terms and Conditions</h1>
        <span>Orion Stars– Terms and Conditions</span>
        <span>
          These Terms and Conditions outline the rules and guidelines governing
          your use of our website and services.
        </span>
        <span>
          By accessing or using our platform, you agree to the terms outlined
          here, forming a legal agreement between you and {" "}
          <span>
            <a href="https://orionstar777slots.com/"> Orion Stars</a>
          </span>
          .
        </span>
        <p>
          Please read this document carefully to ensure a secure and seamless
          experience.
        </p>
        <h2>1. Acceptance of Terms:</h2>
        <p>
          By accessing or using the Orion Stars website, you agree to adhere to
          and be bound by these Terms and Conditions. If you do not accept any
          part of these terms, you are not permitted to use our services.
        </p>
        <h2>2. Eligibility:</h2>
        <p>
          To access and use the services provided by Orion Stars, you must be at
          least 18 years old or meet the legal age required in your
          jurisdiction. By using our platform, you confirm that you fulfill this
          eligibility requirement.
        </p>
        <h2>3. Account Registration:</h2>
        <p>
          To access specific features on Orion Stars, you may need to create an
          account. You agree to provide accurate, complete information during
          registration and update it as needed. You are responsible for
          safeguarding your account details and for all activities conducted
          under your account.
        </p>
        <h2>4. Responsible Gaming:</h2>
        <p>
          We believe online casinos should be a source of entertainment, not a
          way to earn money. If you think you have a gambling problem, please
          seek help. To support safe play, we provide tools for setting deposit
          limits and self-exclusion.
        </p>
        <h2>5. Deposits and Withdrawals: </h2>
        <p>
          By making a deposit on Orion Stars, you confirm that the funds are
          legally yours and not obtained unlawfully. All withdrawal requests are
          subject to verification procedures. If fraudulent activity or a breach
          of our terms is suspected, we reserve the right to deny or revoke
          withdrawal requests.
        </p>
        <h2>6. Bonus Terms:</h2>
        <p>
          Orion Stars may provide bonuses and promotions, each governed by
          specific terms and conditions. These rules will be clearly outlined,
          and failure to adhere to them could result in the forfeiture of the
          bonus and any related winnings.
        </p>
        <h2>7. Fair Play:</h2>
        <p>
          At Orion Stars, we are committed to providing a secure and fair gaming
          environment. Cheating, collusion, and fraudulent activities are
          strictly prohibited. Any player found engaging in such behavior risks
          having their account suspended or terminated.
        </p>
        <h2>8. Intellectual Property:</h2>
        <p>
          All content on the Orion Stars website, including text, graphics,
          logos, and software, is owned by us and protected by intellectual
          property laws. You are not permitted to copy, distribute, or modify
          any material without our written consent.
        </p>
        <h2>9. Privacy Policy:</h2>
        <p>
          All content on the website, including text, graphics, logos, and
          software, is owned by us and protected by intellectual property laws.
          You are not permitted to copy, distribute, or modify any material
          without our written consent.
        </p>
        <h2>10. Termination of Account:</h2>
        <p>
          Orion Stars reserves the right to suspend, terminate, or restrict your
          account at its sole discretion. This action may be taken if you
          violate our Terms and Conditions, engage in fraudulent activities, or
          any other reason deemed necessary to protect our platform's integrity.
        </p>
        <h2>11. Amendments:</h2>
        <p>
          Orion Stars reserves the right to modify these Terms and Conditions at
          any time. It is your responsibility to review them regularly.
          Continued use of our services after any updates indicates your
          acceptance of the revised terms.
        </p>
        <h2>12. Security and Account Integrity:</h2>
        <p>
          We ensure the security of your account and personal information
          through robust security measures. It is your responsibility to
          safeguard your login credentials. If you suspect unauthorized access
          to your account, notify us immediately. Orion Stars is not responsible
          for losses resulting from unauthorized access due to your failure to
          secure your account details.
        </p>
        <h2>13. Prohibited Activities:</h2>
        <p>
          Any actions that compromise the integrity of Orion Stars are strictly
          forbidden. This includes hacking, tampering with website
          functionality, or using automated tools to gain an unfair advantage.
          Such activities violate our policies and will result in immediate
          action.
        </p>
        <h2>14. Communication:</h2>
        <p>
          You agree to receive communications, such as promotional offers,
          newsletters, and important account updates, using our services. You
          can opt out of promotional messages while receiving essential
          notifications related to your account.
        </p>
        <h2>15. Third-Party Links:</h2>
        <p>
          Our website may include links to third-party sites for your
          convenience. We do not endorse or control the content of these
          external sites. We are not responsible for any damages or losses
          resulting from your interactions with third-party websites.
        </p>
        <h2>16. Indemnification:</h2>
        <p>
          By using our services, you agree to indemnify and hold Orion Stars,
          its affiliates, and their officers, directors, employees, and agents
          from any claims, liabilities, damages, or expenses resulting from your
          use of the services.
        </p>
        <h2>17. Community Guidelines:</h2>
        <p>
          We are committed to maintaining a positive and inclusive gaming
          community. We expect all users to uphold community standards and treat
          each other with respect. Failure to comply with these standards may
          lead to account suspension or termination.
        </p>
        <h2>18. Currency and Exchange Rates:</h2>
        <p>
          Orion Stars supports multiple currencies, and currency conversion
          rates may apply. It is your responsibility to be aware of these rates
          and any related fees when converting funds.
        </p>
        <div>
          <p>
            We appreciate you taking the time to review our extended Terms and
            Conditions. Your gaming experience and safety are paramount to us.
            Should you have any queries or require further assistance, please
            don’t hesitate to contact our dedicated customer support team.
          </p>
          <p>Happy gaming!</p>
        </div>
      </div>
    </>
  );
};

export default TermsAndConditions;
